import clsx from 'clsx';
import { SyntheticEvent, useState } from 'react';
import { Span } from 'atoms/Typography';
import { MaterialInfo } from 'molecules/MaterialInfo';
import { Tooltip } from 'molecules/Tooltip';
import { useTranslations } from 'modules/i18n/useTranslations';
import { IAdaptedProduct } from 'commerce/scayle/utils/adapter/types';
import styles from './styles.module.css';

export const ProductMaterialInfo = ({
  size,
  composedMaterials,
  classes,
}: {
  size: IAdaptedProduct['size'];
  composedMaterials?: IAdaptedProduct['composedMaterials'];
  classes?: { root?: string; arrow?: string };
}) => {
  const [open, setOpen] = useState(false);
  const t = useTranslations();

  const preventEventBubbling = (e: Event | SyntheticEvent<Element, Event>) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handleTooltipClose = (e: Event | SyntheticEvent<Element, Event>) => {
    preventEventBubbling(e);
    setOpen(false);
  };

  const handleTooltipOpen = (e: Event | SyntheticEvent<Element, Event>) => {
    preventEventBubbling(e);
    setOpen(true);
  };

  return !composedMaterials?.value ? null : (
    <Tooltip
      element={<MaterialInfo composedMaterials={composedMaterials} />}
      open={open}
      classes={{
        root: clsx(styles.materialTooltip, classes?.root),
        arrow: clsx(styles.materialTooltipArrow, classes?.arrow),
      }}
      onClose={handleTooltipClose}
      onClick={preventEventBubbling}
    >
      <Span className={styles.productMaterial}>
        {t('product.pdp.header.exclusive')}{' '}
        <Span
          onClick={open ? handleTooltipClose : handleTooltipOpen}
          className={styles.productMaterialLink}
        >
          {t('product.pdp.header.materials')}
        </Span>
        {size[0].value && ', '}
      </Span>
    </Tooltip>
  );
};
